"use strict";
const angular = require("angular");
import _ from "lodash";
import { runInThisContext } from "vm";

export class patientListComponent {
  totals;

  /*@ngInject*/
  constructor(appConfig, $uibModal, $http) {
    this.constants = appConfig;
    this.$uibModal = $uibModal;
    this.$http = $http;
  }

  //$onInit/$onChanges not notifying, so use a $doCheck to watch for summary being available and calc totals
  $doCheck(changesObj) {
    if (!this.summary || this.totals) {
      return;
    }
    this.totals = {
      minor: 0,
      major: 0,
      fatal: 0
    };

    this.updateTotals();
  }

  hasUnspecified() {
    let hasUnspec = false;
    if (!this.summary) return;
    Object.keys(this.summary).every(key => {
      if (key.startsWith("injuriesunspe") && this.summary[key] > 0)
        hasUnspec = true;
      return true;
    });

    return hasUnspec;
  }

  updateTotals() {
    this.totals.minor =
      this.summary.injuriesminorGuest +
      this.summary.injuriesminorGuide +
      this.summary.injuriesminorPilot +
      this.summary.injuriesminorStaff;

    this.totals.major =
      this.summary.injuriesmajorGuest +
      this.summary.injuriesmajorGuide +
      this.summary.injuriesmajorPilot +
      this.summary.injuriesmajorStaff;

    this.totals.fatal =
      this.summary.fatalGuest +
      this.summary.fatalGuide +
      this.summary.fatalPilot +
      this.summary.fatalStaff;

    console.log(this.summary);
    console.log("update totals here");
  }

  editPatient(patient) {
    let modal = this.$uibModal.open({
      animation: true,
      size: "lg",
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("../patientDetails/patientDetailsPopup.html"),
      controller: "PatientDetailsPopupController",
      controllerAs: "$ctrl",
      resolve: {
        patient: () => _.clone(patient),
        incidentType: () => this.incident.incidentType
      }
    });

    modal.result.then(result => {
      if (result) {
        if (result.type == "add") {
          const p = result.patient;
          let fp = _.find(this.patients, { id: p.id });
          if (fp) {
            _.assign(fp, p);
          }
        } else if (result.type == "delete") {
          _.remove(this.patients, p => p.id == result.patient.id);
        }
      }
    });
  }

  addNewPatient() {
    var patientModal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("../addPatient.html"),
      controller: "AddPatientController",
      controllerAs: "$ctrl",
      resolve: {
        incidentId: () => this.incident.id
      }
    });

    patientModal.result.then(patient => {
      if (!patient) {
        return;
      }

      if (!this.patients) {
        this.patients = [];
      }

      this.patients.push(patient);
      this.editPatient(patient);
    });
  }
}

export default angular
  .module("hccApp.patientList", [])
  .component("patientList", {
    template: require("./patientList.html"),
    bindings: { patients: "=", summary: "=", incident: "=" },
    controller: patientListComponent
  }).name;



// WEBPACK FOOTER //
// ./client/app/incident/patient/patientList/patientList.component.js